var r = function r(_r) {
  return _r[0].toUpperCase() + _r.substring(1);
};
export { r as upcase };